module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/niX9O8/tc-custom/9781783469529.jpg?1728724846617",
      "alt": "This image is the cover for the book Foul Deeds in Islington, Foul Deeds & Suspicious Deaths"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Foul Deeds in Islington, Foul Deeds & Suspicious Deaths\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Foul Deeds in Islington takes the reader on a sinister journey through a selection of the most shocking and revealing murders committed in this part of north London during the last two centuries. Killers of all kinds are recorded here, from the coolest and most calculating of criminals to ill-starred individuals who struck out in passion or despair or anger. John Eddleston recounts their notorious stories in forensic detail. Police-killers Thomas Cooper and Ronald Marwood feature in his book, along with the child-killer Celestika Somner, the poisoner George Chapman, the witchcraft-murderer Kayode Orishagbemi and, of course, most famous of all, Kenneth Halliwell who killed playwright Joe Orton in their flat in Noel Road. In addition to these celebrated cases, several less well-known but equally compelling murders are reconstructed. They give a shocking insight into the dark side of Islington s recent, sometimes gruesome, history.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John J. Eddleston\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wharncliffe\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0